import { render } from "./DeviceSetting.vue?vue&type=template&id=7a0fa50f&scoped=true"
import script from "./DeviceSetting.vue?vue&type=script&lang=js"
export * from "./DeviceSetting.vue?vue&type=script&lang=js"

import "./DeviceSetting.vue?vue&type=style&index=0&id=7a0fa50f&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0fa50f"]])

export default __exports__